import { useLocation, useNavigate } from "react-router-dom";

export const useSectionNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (href) => {
        if (href.startsWith("#")) {
            if (location.pathname !== "/") {
                try {
                    sessionStorage.setItem("scroll_to", href.slice(1));
                } catch {
                    /* ignore */
                }
                navigate("/");
                return;
            }
            const el = document.querySelector(href);
            if (!el) return;
            const y = Math.max(0, el.getBoundingClientRect().top + window.scrollY - 80);
            if (window.__lenis) {
                window.__lenis.resize();
                window.__lenis.scrollTo(y, { duration: 1.2 });
            } else window.scrollTo({ top: y, behavior: "smooth" });
        } else {
            navigate(href);
        }
    };
};
